import React, { useState, useMemo, useRef, useEffect } from 'react';
import {Select, Spin } from 'antd';
import debounce from 'lodash/debounce';

export default function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = useRef(0);
  useEffect(()=>{
    fetchOptions().then((newOptions) => {
      setOptions(newOptions);
      setFetching(false);
    });
  },[])
  useEffect(()=>{
    if (props.options) {
      setOptions(props.options)
    }
  },[props.options])

  useEffect(()=>{
    console.log(props.value);
  },[props.value])
  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(newOptions);
        setFetching(false);
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      // labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  );
}
